import type { ImageLoaderProps } from 'next/image';
import type { AllowedCropTypes } from 'components/UI/Image';
import { slugify } from './string';

export const getImageLoader = (
  src: string,
  filename: string,
  crop: AllowedCropTypes,
  mimeType = 'webp',
  maxHeight?: number
) => {
  const name = slugify(filename);
  const isFreeCrop = crop === 'original';

  if (src.includes('rtl.de')) {
    if (isFreeCrop) {
      return {
        loader: ({ src, width }: ImageLoaderProps) =>
          `${src}o/${width}/${(maxHeight ?? 0).toString()}/${name}.${mimeType}`,
        unoptimized: false,
      };
    }
    return {
      loader: ({ src, width }: ImageLoaderProps) => `${src}${crop}/${width}/${name}.${mimeType}`,
      unoptimized: false,
    };
  }

  return {
    // loader is in this case only a placeholder
    loader: ({ src }: ImageLoaderProps) => src,
    unoptimized: true,
  };
};
